import React from 'react';
import Helmet from 'react-helmet';

interface Props {
  title: string;
  description: string;
}

const MetaData = (props: Props) => {
  const { title, description } = props;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default MetaData;
